// XX: The file must be .js to be picked up by next-sitemap.config.js

// Blogs that are redirected elsewhere and should not be included in the blog feed at `/blog`.
export const redirectedBlogs = [
  "snowflake-to-salesforce",
  "bigquery-to-google-ads",
  "snowflake-to-hubspot",
  "bigquery-to-salesforce",
  "snowflake-to-google-ads",
  "redshift-to-google-ads",
  "bigquery-to-hubspot",
  "redshift-to-hubspot",
  "redshift-to-salesforce",
  "why-buy-a-customer-data-platform",
  "why-your-customer-data-platform-cdp-should-be-the-data-warehouse",
  "databricks-vs-snowflake-the-definitive-guide",
  "warehouse-identity-resolution",
  "the-marketers-guide-to-facebook-capi",
  "hightouch-vs-rudderstack",
  "broken-promises-salesforce-cdp",
];

// Blogs that are not indexed by search engines should not be included in the sitemap. They may still show up in the feed at `/blog`.
export const noIndexBlogs = ["introducing-ai-decisioning-platform", ...redirectedBlogs];
